/* eslint-disable no-dupe-keys */
import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: '',
    name: 'children_id',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: 'Name *',
    name: 'full_name',
    layout: 'fullWidth',
    maxLength: 100,
    validators: [
      {
        check: 'required',
        error: 'Please enter a full name',
      },
    ],
  },
  {
    label: 'Date of birth (DD/MM/YYYY)*',
    name: 'date_of_birth',
    layout: 'fullWidth',
    validators: [
      {
        check: 'required',
        error: 'Please enter date of birth',
      },
      {
        check: 'dateFormatDMY',
        error: 'Please enter a valid date in the format DD/MM/YYYY',
      },           
    ],
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/PartnerChildrenForm.js